import React, { useContext } from 'react'
import {AppBar, Toolbar, Typography,Box, Button} from '@mui/material'
import { CartContext } from '../Context/Cart'
import { Link } from 'react-router-dom'
const Navbar = () => {
    const { cartItems } = useContext(CartContext)
  return (
    <>
    <AppBar position='sticky' style={{backgroundColor: 'black'}}>
        <Toolbar>
            <Typography variant='h4' style={{color: 'white'}} sx={{flexGrow: 1}}>
                Shop
            </Typography>
            <Box>
                <Button><Link to='/' style={{color:'white'}}>Product</Link></Button>
                <Link to='/cart'><button className='px-4 py-2 bg-gray-800 text-white text-xs font-bold uppercase rounded hover:bg-gray-700 focus:outline-none focus:bg-gray-700'
                    >Cart ({cartItems.length})</button></Link>
            </Box>
        </Toolbar>
    </AppBar>
    </>
  )
}

export default Navbar